// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3kXLK","Open":"SideDrawer_Open__1tCv1","Close":"SideDrawer_Close__9j7x-","SideLogo":"SideDrawer_SideLogo__1WvTJ"};